import React from 'react'
import { PersonLink, RelationshipLink } from '../../app/Links'
import { camelCaseToReadable } from '../../../util/StringUtil'

export default function TreeChangesTableIdsColumn({
  treeContributionsData,
  contribution,
  personIdFields,
  relationshipIdFields,
}) {
  return Object.entries(contribution)
    .filter(([key]) => relationshipIdFields.includes(key) || personIdFields.includes(key))
    .map(([key, value]) => {
      return (
        <div key={`${key}_${contribution.type}_${contribution.modified}`}>
          <strong>{camelCaseToReadable(key).replace('Id', 'ID')}: </strong>
          <span>
            {relationshipIdFields.includes(key) ? (
              <RelationshipLink relationshipId={value} relationshipType={key.replace('Id', '').toLowerCase()} />
            ) : (
              <PersonLink
                personId={value}
                personName={
                  treeContributionsData.tfUserContributions.persons.find((person) => person.id === value).summary.name
                }
                showId
              />
            )}
          </span>
        </div>
      )
    })
}
